import { staticImplements } from '@/decorators/staticImplements';
import { httpClient } from '../httpClient/httpClient';
import { ServiceSuccess } from '@/api/interfaces/serviceSuccess';
import { AuthenticationRepositoryInterface } from '@/api/interfaces/authentication/authenticationRepository';
import { DeaAdditionalUserData } from '@/api/interfaces/authentication/deaAdditionalUserData';

@staticImplements<AuthenticationRepositoryInterface>()
export class AuthenticationRepository {
    static async logoutToken(): Promise<ServiceSuccess> {
        return httpClient.post<ServiceSuccess>(
            `/api/dea/v1/authentication/logoutToken`,
        );
    }

    static async getAdditionalUserData(): Promise<DeaAdditionalUserData> {
        return httpClient.get<DeaAdditionalUserData>(
            `/api/dea/v1/authentication/additionalUserData`,
        );
    }
}
